import React, { useState } from "react";
import { Button, Menu, MenuProps } from "antd";
import { menuItems } from "../../../../config/Menu";
import {
  ReceivePurchaseOrderModal,
  clearPurchaseOrderDraftStorage,
} from "../../../inventory/component/PurchaseOrderMenuItems";
import companyLogo from "../../../../assets/logo.svg";
import styles from "./ProtectedLayout.module.scss";
import { LogoutIcon } from "../../../../component/icon";
import { translate } from "../../../../core";
import { resolveMenuItem } from "../../../../core/until";
import { authService } from "../../../auth/service";
import { useNavigate } from "react-router-dom";
import { MenuItem, Nullable } from '../../../../core/type'

const environmentInspector = (item: MenuItem): Nullable<MenuItem> => {
  const isProd = process.env.REACT_APP_NODE_ENV === 'production'

  if(item.underDevelop && isProd)
    return null

  item.children = item.children?.length
    ? item.children.map(environmentInspector).filter(Boolean) as MenuItem[]
    : item.children

  return item
}

export const SideMenu: React.FC<{ sideBarEnabled: boolean }> = ({
  sideBarEnabled,
}) => {
  const navigate = useNavigate();
  const [receiveOpen, setReceiveOpen] = useState(false);

  const handleMenuClick: MenuProps["onClick"] = ({ key }) => {
    if (key === "purchase-order-new") {
      clearPurchaseOrderDraftStorage();
      navigate("/purchase-order/new");
    } else if (key === "purchase-order-receive") {
      setReceiveOpen(true);
    }
  };

  const items = menuItems
    .map(environmentInspector)
    .filter(Boolean)
    .map(item => {
      const menuItem = item as MenuItem;
      const onTitleClick =
        menuItem.path && menuItem.children?.length
          ? () => navigate(menuItem.path as string)
          : undefined;
      return { ...menuItem, onTitleClick, label: resolveMenuItem(menuItem) };
    }) as MenuItem[]
  const pathname = window.location.pathname || "";
  const selectedItem = menuItems.find((e) => e.path === pathname)
    ?.key as string;

  const logout = () => {
    authService.logout();
    navigate("/login");
  };

  return (
    <div className="d-flex flex-column">
      {!sideBarEnabled ? (
        <div
          className={
            "bg-white d-flex p-4 justify-content-center " + styles.menuLogo
          }
          style={{ height: 100 }}
        >
          <img src={companyLogo} alt={""} className="w-75" />
        </div>
      ) : (
        <div className={styles.menuLogo} style={{ height: 100 }}></div>
      )}

      <Menu
        className={styles.menuSider}
        defaultSelectedKeys={["1"]}
        defaultOpenKeys={["sub1"]}
        mode="inline"
        theme="dark"
        inlineCollapsed={false}
        items={items}
        selectedKeys={[selectedItem]}
        onClick={handleMenuClick}
      />

      <ReceivePurchaseOrderModal
        open={receiveOpen}
        closeMe={() => setReceiveOpen(false)}
      />

      <div className={styles.menuSiderFooter}>
        <Button
          onClick={logout}
          className="text-white"
          block
          type="text"
          icon={<LogoutIcon />}
        >
          {!sideBarEnabled ? translate("log_out") : ""}
        </Button>
      </div>
    </div>
  );
};
